module.exports = __webpack_public_path__ + "img/mh.a0e8da71.jpg";